const CORREOS = '05';
const PACKSTATION = '04';
const PICK_UP_IN_STORE = '99';
const POSTFILIALE = '06';
const RETURN_TO_DROPOFF = '05';
const RETURN_TO_STORE = '06';
const SAME_DAY_DELIVERY = '03';
const SHIPPING_EXPRESS = '02';
const STANDARD = '01';

const SAME_DAY_DELIVERY_DISTRICTS = [
  'ATAŞEHİR',
  'AVCILAR',
  'BAĞCILAR',
  'BAHÇELİEVLER',
  'BAKIRKÖY',
  'BAŞAKŞEHİR',
  'BAYRAMPAŞA',
  'BEŞİKTAŞ',
  'BEYLİKDÜZÜ',
  'BEYOĞLU',
  'ÇEKMEKÖY (Excluded: ALEMDAĞ MAH, ÇATALMEŞE MAH, NİŞANTEPE MAH, HÜSEYİNLİ MAH, KOÇULLU MAH, ÖMERLİ MAH, REŞADİYE MAH, SIRAPINAR MAH)',
  'ESENLER',
  'ESENYURT',
  'EYÜPSULTAN (Excluded: MİTHATPAŞA MAH, AĞAÇLI MAH, AKPINAR MAH, ÇİFTALAN MAH, IŞIKLAR MAH, İHSANİYE MAH, ODAYERİ MAH, PİRİNÇÇİ MAH)',
  'FATİH',
  'GAZİOSMANPAŞA',
  'GÜNGÖREN',
  'KADIKÖY',
  'KAĞITHANE',
  'KARTAL',
  'KÜÇÜKÇEKMECE',
  'MALTEPE',
  'PENDİK (Excluded: BALLICA MAH, EMİRLİ MAH, GÖÇBEYLİ MAH, KURNA MAH, KURTDOĞMUŞ MAH)',
  'SANCAKTEPE (Excluded: PAŞAKÖY MAH)',
  'SARIYER (Excluded: BAHÇEKÖY KEMER MAH, DEMİRCİKÖY MAH, GARİPÇE MAH, KISIRKAYA MAH, KISIRKAYA MAH, KUMKÖY  MAH (KİLYOS MAH), RUMELİFENERİ MAH, RUMELİKAVAĞI MAH, USKUMRUKÖY MAH, YENİ MAH, GÜMÜŞDERE MAH, KAZIM KARABEKİR PAŞA MAH, MADEN MAH, SARIYER MERKEZ MAH)',
  'SULTANGAZİ',
  'ŞİŞLİ',
  'ÜMRANİYE (Excluded: DUMLUPINAR MAH, HEKİMBAŞI MAH, TOPAĞACI MAH)',
  'ÜSKÜDAR',
  'ZEYTİNBURNU',
];

const ROYAL_MAIL_URL = 'https://www.royalmail.com/track-my-return#/details/7440';

module.exports = {
  CORREOS,
  PACKSTATION,
  PICK_UP_IN_STORE,
  POSTFILIALE,
  RETURN_TO_DROPOFF,
  RETURN_TO_STORE,
  SAME_DAY_DELIVERY,
  SHIPPING_EXPRESS,
  STANDARD,
  SAME_DAY_DELIVERY_DISTRICTS,
  ROYAL_MAIL_URL,
};
